import { Tooltip } from "antd"
import { VyneButton } from "@vynedental/design-system"
import { PrintOutlined } from "@mui/icons-material"
import { useState } from "react"
import { useClaimControlContext } from "trellis:components/claims/context/claimControlContext"
import { useQuery } from "@tanstack/react-query"
import { ClaimsApiFactory } from "trellis:api/claim/claimsApiFactory"
import { useClaimGridContext } from "trellis:components/claims/context/claimGridContext"
import { showMessage } from "trellis:utilities/general"
import { NotifyText } from "trellis:constants/notifyText"
import { Errors } from "trellis:constants/errors"

export const GridToolbarPrint = () => {

  const [handlePrint, setHandlePrint] = useState(false)

  const { getPrintDownloadReq } = useClaimControlContext()
  const { isPmg, state } = useClaimGridContext()

  const { data: printData, error: printError, isFetching: isFetchingPrint } = useQuery({
    queryKey: ['print'],
    queryFn: () => ClaimsApiFactory().PrintClaims(getPrintDownloadReq()),
    enabled: handlePrint
  })

  const onPrint = () => {
    if (state.Total < 2500) setHandlePrint(true)
    else showMessage(NotifyText.printClaimsError)
  }

  if (printData?.data && handlePrint) {
    window.open(printData.data?.PdfLink, '_blank')
    setHandlePrint(false)
  }

  if (printError && handlePrint) {
    showMessage(Errors.somethingUnexpectedError)
    setHandlePrint(false)
  }

  return (
    <Tooltip
      title='Print'
      mouseEnterDelay={0.5}
    >
      <VyneButton
        className='grid-control-button'
        dataTestId='grid-toolbar-print-icon'
        disabled={isPmg || isFetchingPrint}
        icon={<PrintOutlined />}
        loading={isFetchingPrint}
        onClick={onPrint}
      />
    </Tooltip>
  )
}
